import { ThemeProvider } from '@emotion/react';
import theme from './themes';
import { useScrollToTop } from './hooks/use-scroll-to-top';
import './index.css';
import Router from './routes/routes';
const App = () => {
  useScrollToTop();
  return (
    <ThemeProvider theme={theme}>
      <Router />
    </ThemeProvider>
  );
};

export default App;
